import { CSSProperties } from 'react';

const FULL_WIDTH = 600;
const GC_FULL_WIDTH = 375;
const HALF_WIDTH = FULL_WIDTH / 2;
const COLUMN_GAP = 12;
const BORDER_COLOR = '#e5e5e5';

const INPUT_STYLES = {
  backgroundColor: 'transparent',
  boxShadow: 'none',
  fontSize: '15px',
  height: '1.2em',
  width: '100%',
};

const ERROR_MESSAGE_STYLES = {
  height: '24px',
  margin: 0,
  fontSize: '13px',
  lineHeight: '1.375',
  color: '#e70000',
}

export const GIFTCARD_STYLES: Record<string, CSSProperties | unknown> = {
  'body': {
    fontFamily: '"Graphik", "Helvetica", sans-serif',
  },
  'label': {
    display: 'block',
    fontSize: '12px'
  },
  'input': {
    ...INPUT_STYLES,
    marginTop: '14px',
    borderBottom: `1px solid ${BORDER_COLOR}`,
    width: '100%',
  },
  'section': {
    'display': 'flex',
    'flexWrap': 'wrap',
    'column-gap': `${COLUMN_GAP}px`,
    'width': `${GC_FULL_WIDTH}px`,
    '& > div': {
      marginTop: '0.5em',
      width: '30%',
    },
    '& > div:first-child': {
      width: '50%',
    }
  },
  '.checkoutElements': {
    width: `${GC_FULL_WIDTH}px`
  },
  '.errorMessage': {...ERROR_MESSAGE_STYLES},
}

export const ACH_STYLES: Record<string, CSSProperties | unknown> = {
  'body': {
    fontFamily: '"Graphik", "Helvetica", sans-serif',
  },
  'label': {
    display: 'block',
    fontSize: '12px'
  },
  'input': {
    ...INPUT_STYLES,
    marginTop: '14px',
    borderBottom: `1px solid ${BORDER_COLOR}`,
    width: 'inherit',
  },
  'select': {
    ...INPUT_STYLES,
    border: 'none',
    borderBottom: `1px solid ${BORDER_COLOR}`,
  },
  'br': {
    display: 'none',
  },
  'section': {
    'display': 'flex',
    'flexWrap': 'wrap',
    'columnGap': '12px',
    'width': '100%',
    '& div': {
      marginTop: '0.5em',
      width: `${HALF_WIDTH - COLUMN_GAP/2}px`,
    }
  },
  '.sectionHeader': {
    width: '100%',
    marginTop: '12px',
    fontSize: '12px',
    marginBottom: '3px',
    fontWeight: 'bold',
  },
  '.checkoutElements': {
    width: `${FULL_WIDTH}px`
  },
  '.errorMessage': {...ERROR_MESSAGE_STYLES},
  '.fieldError': {
    '& input': {
      borderColor: 'red'
    }
  }
};

export const CC_STYLES: Record<string, CSSProperties> = {
  '.hydrated' : {
    display: 'block',
    height: '2em',
    overflow: 'hidden',
  },
  'input': {
    ...INPUT_STYLES
  },
  'img': {
    height: '1.2em !important',
    width: '1.8em',
  }
};
